import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.COMPLAINT_ASSIGN.REQUEST, saga.assignComplaint);
    yield takeEvery(ACTION.COMPLAINT_ASSIGN.SUCCESS, saga.onAssignComplaintSuccess);
    yield takeEvery(ACTION.COMPLAINT_ASSIGN.FAILED, saga.onAssignComplaintFailed);
}
